import { Dispatch } from 'redux'

import { getAll, getOne } from 'redux/api/ResourceFilter'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'
import { selectGlobalFilterForApi } from 'redux/selectors/GlobalFilter'
import { ApplicationState } from 'redux/Stores/types'

function tryGetResourceFilterOptions() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

function tryGetResourceFilterData(
  fetchOptions: { saveKey: string; attributeId: string }[]
) {
  return async (dispatch: Dispatch, getState: () => ApplicationState) => {
    dispatch(actions.getData(fetchOptions.map((option) => option.saveKey)))

    const globalFilter = selectGlobalFilterForApi(getState())

    const responses = await Promise.all(
      fetchOptions.map(async (option) => {
        let response: string[] = []

        try {
          response = (await getOne(option.attributeId, globalFilter)).data.data
        } catch (e) {
          // Do nothing
        }

        return {
          options: response,
          attributeId: option.saveKey
        }
      })
    )

    dispatch(actions.getDataSuccess(responses))
  }
}

export const useResourceFilterActions = () => {
  return {
    tryGetResourceFilterOptions: useThunkActions(tryGetResourceFilterOptions),
    tryGetResourceFilterData: useThunkActions(tryGetResourceFilterData)
  }
}
